//=====================================================
//　医院情報
//=====================================================

import { useContext } from "react";
import { CtxClinicInfo } from "../../utils/Contexts";
import { ClinicInfoSlider } from "./ClinicInfoSlide";

export function ClinicInfo(){

    const cci = useContext(CtxClinicInfo);

    return (
        <div className="clinic_info">
            <ClinicInfoSlider />
            <div className="clinic_info-text">
                <div className="clinic_info-text-left">
                    <p className="clinic_info-name text-l">{cci.data.name}</p>
                    {(cci.data.postalCode || cci.data.address) &&
                        <p className="clinic_info-address">
                            {cci.data.postalCode && "〒" + cci.data.postalCode}
                            {(cci.data.postalCode && cci.data.address) && <br/>}
                            {cci.data.address && cci.data.address}
                        </p>
                    }
                    {cci.data.googleMapsUrl &&
                        <p className="clinic_info-map"><a href={cci.data.googleMapsUrl} target="_blank" rel="noreferrer">Google Map</a></p>
                    }
                    {cci.data.nearestTime && 
                        <p className="clinic_info-access text-multiline">{cci.data.nearestTime}</p>
                    }
                    {cci.data.tel &&
                        <p className="clinic_info-tel">{cci.data.tel}</p>
                    }
                    {cci.data.clinicUrl &&
                        <p className="clinic_info-url"><a href={cci.data.clinicUrl} target="_blank" rel="noreferrer">{cci.data.clinicUrl}</a></p>
                    }
                </div>
                <div className="clinic_info-text-right">
                    <dl className="clinic_info-service">
                        {cci.data.consultationHours &&
                            <>
                                <dt>診療時間</dt>
                                <dd className="clinic_info-hours text-multiline">{cci.data.consultationHours}</dd>
                            </>
                        }
                        {cci.data.closedDays &&
                            <>
                                <dt>休診日</dt>
                                <dd className="clinic_info-closed text-multiline">{cci.data.closedDays}</dd>
                            </>
                        }
                        {cci.data.medicalItem &&
                            <>
                                <dt>診療科目</dt>
                                <dd className="clinic_info-subject text-multiline">{cci.data.medicalItem}</dd>
                            </>
                        }
                    </dl>
                </div>
            </div>
        </div>
    )

}